import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '../../../../core';
import { Campanha } from '../campanha';
import { CampanhaFilter } from '../filter';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class CampanhaCrudHttpService {
    resource = 'campanha';

    constructor(private crudService: CrudService) { }

    /** Procura uma única campanha através do seu ID */
    find(id: number): Observable<Campanha> {
        return this.crudService.find<Campanha>(this.resource, id);
    }

    /** Carrega uma única campanha através do seu ID */
    load(id: number, filter: CampanhaFilter = null, status: number = null): Observable<Campanha> {
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Status
        if (status) {
            params = params.append('status', status.toString());
        }

        return this.crudService.load<Campanha>(this.resource, id, {params});
    }

    /** Insere uma nova campanha */
    insert(entity: Campanha, loadAfter = false): Observable<Campanha> {
        let params = new HttpParams();
        if (loadAfter) {
            params = params.append('loadAfter', 'true');
        }
        return this.crudService.insert<Campanha>(this.resource, entity, {params});
    }

    /** Altera uma campanha existente */
    update(entity: Campanha, loadAfter = false): Observable<Campanha> {
        let params = new HttpParams();
        if (loadAfter) {
            params = params.append('loadAfter', 'true');
        }
        return this.crudService.update<Campanha>(this.resource, entity, {params});
    }

    /** Exclui uma campanha através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
